import React from 'react';
import type { ProjectSearchMode } from '../../utils/api/division';

const MODES: { value: ProjectSearchMode; label: string; title: string }[] = [
  { value: 'contains', label: 'Lenient', title: 'Match anywhere in a project or client name' },
  { value: 'prefix', label: 'Strict', title: 'Match the start of a project or client name' },
];

/** SW2-2580 — search mode dropdown, shown inside the right edge of the Projects search bar. */
function ProjectSearchModeToggle({
  mode,
  onChange,
}: {
  mode: ProjectSearchMode;
  onChange(mode: ProjectSearchMode): void;
}) {
  return (
    <select
      className='project-search-mode'
      aria-label='Search match'
      title={MODES.find((m) => m.value === mode)?.title}
      value={mode}
      onChange={(e) => onChange(e.target.value as ProjectSearchMode)}
    >
      {MODES.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}

export default ProjectSearchModeToggle;
